// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"99a2cd51","453":"2475a2cf"}[chunkId] + ".chunk.js";
};